import { render, staticRenderFns } from "./CompanyHeader.vue?vue&type=template&id=350200ec&scoped=true"
import script from "./CompanyHeader.vue?vue&type=script&lang=js"
export * from "./CompanyHeader.vue?vue&type=script&lang=js"
import style0 from "./CompanyHeader.vue?vue&type=style&index=0&id=350200ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350200ec",
  null
  
)

export default component.exports